import { FC, SVGProps } from 'react';

const TickSquareIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  size = 20,
  color = '#2D2D2D',
  ...props
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.612 2.29184H6.38783C3.87033 2.29184 2.29199 4.07434 2.29199 6.59684V13.4035C2.29199 15.926 3.86283 17.7085 6.38783 17.7085H13.6112C16.137 17.7085 17.7087 15.926 17.7087 13.4035V6.59684C17.7087 4.07434 16.137 2.29184 13.612 2.29184Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.03326 10.0002L9.0116 11.9777L12.9666 8.02267"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default TickSquareIcon;
